export const GROUP_SUPERADMIN = 1
export const GROUP_ADMIN = 2
export const GROUP_MUSEUM = 3



// WEBPACK FOOTER //
// ./src/const.js